import styled from "styled-components";

export const UserRoles = styled.div`
  width: fit-content;
  padding: 0px 8px;
  background-color: #cccccc;
  border-radius: 2px;
  word-break: break-all !important;
  padding-left: 5px !important;
`;
export const UsersTableColumn = styled.div`
  word-break: break-all !important;
  padding-left: 5px !important;
`;
